import type { FC, ReactNode } from 'react'
import { ExclamationCircleIcon, InformationCircleIcon } from '@heroicons/react/24/outline'
import { classNames } from '@g4g/utils/src/react/class-names'

const AttentionBox: FC<{
  info?: boolean
  className?: string
  secondary?: boolean
  children?: ReactNode
  as?: keyof JSX.IntrinsicElements
  iconCentered?: boolean
  filled?: boolean
}> = ({ info, className, secondary, children, as: Component = 'p', iconCentered, filled }) => (
  <div
    data-cy="ui-attention-box"
    className={classNames(
      className,
      'flex items-center justify-center space-x-2 text-sm font-bold',
      filled && 'px-4 py-5 rounded-md text-white w-full',
      info && !secondary && (filled ? 'bg-blue-700' : 'text-blue-300'),
      info && secondary && (filled ? 'bg-gray-700' : 'text-white/50'),
      !info && !secondary && (filled ? 'bg-red-700' : 'text-[#FF5C5C]')
    )}
  >
    <div className={classNames('flex w-6 h-6', iconCentered ? 'self-center' : 'self-start')}>
      {info ? <InformationCircleIcon /> : <ExclamationCircleIcon />}
    </div>
    <Component className="text-left">{children}</Component>
  </div>
)

export default AttentionBox
